import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      d: "M15 22H5.909C4.856 22 4 21.047 4 19.875V4.125C4 2.953 4.857 2 5.909 2h9.09a1 1 0 1 1 0 2.002L6.022 4A.4.4 0 0 0 6 4.125v15.75c0 .055.01.097.021.125H15a1 1 0 1 1 0 2m4.716-10.707-3-3a.999.999 0 1 0-1.414 1.414L16.595 11H10a1 1 0 0 0 0 2h6.595l-1.293 1.293a.999.999 0 1 0 1.414 1.414l3-3A1 1 0 0 0 20 12a1 1 0 0 0-.284-.707"
    }, null, -1)
  ]))]))
}
export default { render: render }